(function(app, ng) {

    app.config([
        "figModalStateProvider", function(figModalStateProvider) {
            figModalStateProvider.state("Transaction.Capture.RetireUp",
            {
                url: "/RetireUp",
                component: "captureRetireUp",
                resolve: {
                
                }
            });
        }
    ]);

    app.component("captureRetireUp",
    {
        templateUrl: "/App/Transaction/Capture/RetireUp/template.html",
        controller: captureRetireUpController
    });

    captureRetireUpController.$inject = ["$scope", "$state"];
    function captureRetireUpController($scope, $state) {
        $scope.$parent.$ctrl.getCurrentStage($state);

        var $ctrl = this;

        ng.extend($ctrl,
        {

        });
    };

})(window.app, window.angular); //jshint ignore:line